import { createClient } from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'
import type { SanityImageSource } from '@sanity/image-url/lib/types/types'

const projectId =
  process.env.SANITY_PROJECT_ID ??
  process.env.SANITY_STUDIO_PROJECT_ID ??
  process.env.NEXT_PUBLIC_SANITY_PROJECT_ID

const dataset =
  process.env.SANITY_DATASET ??
  process.env.SANITY_STUDIO_DATASET ??
  process.env.NEXT_PUBLIC_SANITY_DATASET

if (!projectId || !dataset) {
  throw new Error(
    'Missing Sanity env vars-add SANITY_PROJECT_ID and SANITY_DATASET (plus NEXT_PUBLIC_… for browser code).',
  )
}

export const sanity = createClient({
  projectId,
  dataset,
  apiVersion: process.env.SANITY_API_VERSION ?? '2025-07-24',
  useCdn: process.env.NODE_ENV === 'production',
})

const builder = imageUrlBuilder(sanity)
export const urlFor = (src: SanityImageSource) =>
  builder.image(src).auto('format').fit('max')
